import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Menu } from "antd";
import { useNavigate, useLocation } from "react-router";
import CryptoJS from "crypto-js";
import "./Sidebar.scss";
import decryptedModulesData from "../../utils/decryptedModulesData";

function Sidebar() {
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedKey, setSelectedKey] = useState("/");
  const token = sessionStorage.getItem("biller_access");

  const menuItems = [
    {
      label: "User",
      key: "/users",
      permission: "users",
    },
    {
      label: "Transactions",
      key: "/transactions",
      permission: "transactions",
    },
    {
      label: "Reversal",
      key: "/reversal",
      permission: "reversal",
    },
    // {
    //   label: "Customer Payment History",
    //   key: "/customer-payment-history",
    //   permission: "payment_history",
    // },
    {
      label: "Complaints",
      key: "/complaints",
      permission: "complaints",
    },
    {
      label: "Milestone",
      key: "/milestone",
      permission: "milestone",
    },
    {
      label: "VLE Details",
      key: "/vle-details",
      permission: "vle_details",
    },
    {
      label: "VLE Earnings",
      key: "/vle-earnings",
      permission: "vle_earnings",
    },
    {
      label: "Home Categories",
      key: "/home-category",
      permission: "home_category",
    },
    {
      label: "All Categories",
      key: "/all-category",
      permission: "all_category",
    },
    {
      label: "Categories Group",
      key: "/category-group",
      permission: "category_group",
    },
    {
      label: "Refund",
      key: "/refund",
      permission: "refund",
    },

    {
      label: "Recon and Settlement",
      key: "/recon",
      permission: "settlements",
    },
    {
      label: "Logger",
      key: "/logger",
      permission: "logger",
    },
  ];

  useEffect(() => {
    if (!token) {
      window.location.href = "/login";
      return null;
    }
    setSelectedKey(location.pathname);
  }, [token, location.pathname]);

  const permissions = decryptedModulesData()?.modules || [];
  // Filter menu items based on permissions
  const filteredMenuItems = [{ label: "Overview", key: "/" }, ...permissions];

  console.log(filteredMenuItems, "filteredMenuItems");

  return (
    <div className="AppSidebar">
      <Menu
        selectedKeys={[selectedKey]}
        defaultSelectedKeys={["/"]}
        onClick={(item) => navigate(item.key)}
        items={Array.isArray(filteredMenuItems) && filteredMenuItems?.map((item) => ({
          label: item?.label || item?.module,
          key: item.key,
        }))}
      />
      {/* <div className='plutos-logo'><img src={plutosLogo} alt='logo' /></div> */}
    </div>
  );
}

export default Sidebar;
